// ---------------------------------------------
// 0. Initialise firebase
// ---------------------------------------------
import Vue from 'vue';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, doc } from 'firebase/firestore';
// const firebaseApp = initializeApp({ /* pass your config... */ })
const config = {
  apiKey: 'AIzaSyDtAqSxnGZSGaaUy-9j2vkXPUFfm17PtGw',
  authDomain: 'auth.context.so',
  databaseURL: 'https://context-v5.firebaseio.com',
  projectId: 'context-v5',
  storageBucket: 'context-v5.appspot.com',
  messagingSenderId: '385146739042',
  appId: '1:385146739042:web:9e64e6dacfa569d5',
  measurementId: 'G-KEY9TNMP5W'
};

const firebaseApp = initializeApp(config);
const db = getFirestore(firebaseApp);
/**
 * A helper function that generates a random Firestore ID
 */
export const generateRandomId = () => {
  return doc(collection(db, 'random')).id;
}

// ---------------------------------------------
// 1. the plugin firestore for remote data store
// ---------------------------------------------
import { CreatePlugin as PluginFirestore } from '@magnetarjs/plugin-firestore';

// create the remote store plugin instance & pass your `db`:
console.log(db);
const remote = PluginFirestore({ db });

// ---------------------------------------
// 2. the plugin vue2 for local data store
// ---------------------------------------
import { CreatePlugin as PluginVue } from '@magnetarjs/plugin-vue2';

// create the local store plugin instance & pass your `generateRandomId`:
const local = PluginVue({ vueInstance: Vue, generateRandomId });

// -----------------------------------------------------
// 3. instantiate the Magnetar instance with the store plugins
// -----------------------------------------------------
import { Magnetar } from 'magnetar';
import { logger } from '@magnetarjs/utils';

export const magnetar = Magnetar({
  stores: { local, remote },
  localStoreName: 'local',
  executionOrder: {
    read: ['local', 'remote'],
    write: ['local', 'remote'],
    delete: ['local', 'remote']
  },
  on: { success: logger } // disable this on production builds
});
